/**
 * Get filter name type
 * @param filterName
 */
export const getFilterType = (filterName: string) => (filterName === 'PRICE' ? '><' : '=')
